import { IBar, INote, ISignature } from "../types";

const syll = {
    t0: {
        gordon: "du",
        taKaDiMi: "ta",
        taKaTiKi: "ta",
    },
    t0_5: {
        gordon: "ta3",
        taKaDiMi: "va",
        taKaTiKi: "ka2",
    },
    t1: {
        gordon: "da",
        taKaDiMi: "ki",
        taKaTiKi: "tu",
    },
    t1_5: {
        gordon: "ta4",
        taKaDiMi: "di2",
        taKaTiKi: "ku",
    },
    t2: {
        gordon: "di",
        taKaDiMi: "da",
        taKaTiKi: "te",
    },
    t2_5: {
        gordon: "ta5",
        taKaDiMi: "ma",
        taKaTiKi: "ke",
    },
    b0: {
        gordon: "du",
        taKaDiMi: "ta",
        taKaTiKi: "ta",
    },
    b1: {
        gordon: "ta2",
        taKaDiMi: "ka",
        taKaTiKi: "ka",
    },
    b2: {
        gordon: "de",
        taKaDiMi: "di",
        taKaTiKi: "ti",
    },
    b3: {
        gordon: "ta",
        taKaDiMi: "mi",
        taKaTiKi: "ki",
    },
};

export const getTakadimiBar = (notes: INote[], signature: ISignature, type: "gordon" | "taKaDiMi" | "taKaTiKi") => {
    const syllables: string[] = [];
    let time = 0;
    const { den, num } = signature;
    const isCompound = num === 6 || num === 9;
    notes.forEach(note => {
        if (note.r) {
            syllables.push("");
        } else {
            if (isCompound || note.t) {
                const beat = note.t ? 3 : ((4 / den) * 3 * 3);
                switch (time % beat) {
                    case 0:
                        syllables.push(syll.t0[type]);
                        break;
                    case beat / 6:
                    case 0.5:
                        syllables.push(syll.t0_5[type]);
                        break;
                    case beat / 3:
                    case 1:
                        syllables.push(syll.t1[type]);
                        break;
                    case beat / 2:
                    case 1.5:
                        syllables.push(syll.t1_5[type]);
                        break;
                    case (beat / 3) * 2:
                    case 2:
                        syllables.push(syll.t2[type]);
                        break;
                    case (beat / 6) * 5:
                    case 2.5:
                        syllables.push(syll.t2_5[type]);
                        break;
                    default:
                        syllables.push("?");
                        break;
                }
            } else {
                switch (time % ((4 / den) * 3)) {
                    case 0:
                        syllables.push(syll.b0[type]);
                        break;
                    case (4 / den / 4) * 3:
                        syllables.push(syll.b1[type]);
                        break;
                    case (4 / den / 2) * 3:
                        syllables.push(syll.b2[type]);
                        break;
                    case (4 / den / 4) * 3 * 3:
                        syllables.push(syll.b3[type]);
                        break;
                    default:
                        syllables.push("?");
                        break;
                }
            }
        }
        time += (4 / note.l) * (note.d ? 1.5 : 1) * (note.t ? 2 : 3);
    });
    return syllables;
};

const getSignatureIndex = (signatures: ISignature[], currentBarIndex: number) => {
    return signatures.findIndex(signature => signature.bar === currentBarIndex);
};

export const getTakadimiScore = (bars: (IBar | null)[], signatures: ISignature[], type: "gordon" | "taKaDiMi" | "taKaTiKi") => {
    let takadimis: string[] = [];
    let signature: ISignature;
    bars.forEach((bar, barIndex) => {
        if (!bar) return;
        const signatureIndex = getSignatureIndex(signatures, barIndex);
        if (signatureIndex !== -1) {
            signature = signatures[signatureIndex];
        }
        takadimis.push(...getTakadimiBar(bar.notes, signature, type));
    });
    return takadimis;
};

export const getTakadimiTypes = (bars: (IBar | null)[], signatures: ISignature[], type: "gordon" | "taKaDiMi" | "taKaTiKi") => {
    const takadimis = getTakadimiScore(bars, signatures, type);
    const uniqueTakadimis = new Set<string>();
    takadimis.forEach(takadimi => {
        uniqueTakadimis.add(takadimi);
    });
    return [...uniqueTakadimis];
};
